import { Link } from 'react-router-dom';

import { Panel } from '../components/ui/Panel';
import { BILLING_LIVE } from '../config';
import { LEGAL_ENTITY, LegalEmail } from './legal/LegalLayout';

/**
 * A real contact route, which Stripe's review looks for and any paid product
 * owes people anyway. Deliberately an email address rather than a form: a form
 * is another thing to build, another place mail gets lost, and at this size
 * the inbox is the support system.
 */
export function ContactPage() {
    return (
        <div className="space-y-6 pb-16">
            <header>
                <h1 className="text-title">Contact</h1>
                <p className="mt-3 text-text-muted">
                    Replies come from a person, usually within a day. There's no ticket queue and no bot.
                </p>
            </header>

            <Panel title="Email">
                <p className="text-lg">
                    <LegalEmail />
                </p>
                {/*
                 * Block form rather than the prose `legalEntityDescription()`,
                 * because this reads as an address, not a sentence. Same fields,
                 * same `regNo` rule, a line appears only once there is one.
                 */}
                <p className="mt-3 text-sm text-text-muted">
                    {LEGAL_ENTITY.name}
                    <br />
                    {LEGAL_ENTITY.regNo ? (
                        <>
                            Registered in Malaysia, SSM no. {LEGAL_ENTITY.regNo}
                            <br />
                        </>
                    ) : null}
                    {LEGAL_ENTITY.address}
                    <br />
                    <span className="text-text-muted">Registration details and full registered address on request.</span>
                </p>
            </Panel>

            <Panel title="Before you write">
                <ul className="space-y-3 text-sm text-text-muted">
                    <li>
                        <span className="text-text">Need more requests than your plan allows.</span>{' '}
                        {BILLING_LIVE ? 'Upgrade on ' : 'Paid plans open shortly. See '}
                        <Link to="/pricing" className="text-primary underline">
                            pricing
                        </Link>{' '}
                        or tell us the volume you need if none of the tiers fit.
                    </li>
                    <li>
                        <span className="text-text">Cancelling.</span>{' '}
                        {BILLING_LIVE ? (
                            <>
                                Sign in and open <span className="text-text">Manage billing</span>, or see{' '}
                                <Link to="/refunds" className="text-primary underline">
                                    cancellation and refunds
                                </Link>
                                . You can also just email and we'll do it.
                            </>
                        ) : (
                            <>
                                Nothing to cancel yet. Paid plans are not open and no card can be charged. What will
                                happen when they are is on{' '}
                                <Link to="/refunds" className="text-primary underline">
                                    cancellation and refunds
                                </Link>
                                .
                            </>
                        )}
                    </li>
                    <li>
                        <span className="text-text">You didn't get a sign-in link.</span> Check spam, then tell us which
                        address you used. If there's a typo on the account we can fix it.
                    </li>
                    <li>
                        <span className="text-text">A key stopped working.</span> Check it wasn't revoked in the console.
                        If it looks live and still fails, send us the request id from the response and we'll dig in.
                    </li>
                </ul>
            </Panel>
        </div>
    );
}
